/**
 * Helpers to read drop targets from dnd-kit events when `over` is unset but collisions
 * still list the cell (measured rect timing vs collision map).
 */

/**
 * Unwrap a dnd-kit `data` ref (`{ current }`) or return a plain data object.
 *
 * @param {unknown} data dnd-kit `data` ref (`{ current }`) or plain object
 * @returns {unknown}
 */
export function readDndDataRef(data) {
  if (data == null) {
    return undefined;
  }
  if (typeof data === "object" && "current" in data) {
    return /** @type {{ current?: unknown }} */ (data).current;
  }
  return data;
}

/**
 * Resolve schedule grid drop payload from a dnd-kit drag-end (or drag-over) event.
 *
 * `event.over` can be null even when collisions hit: the library only sets `over`
 * when `droppable.rect.current` is populated, while collision detection may use
 * the separate measured `droppableRects` map.
 *
 * @param {{ over?: import('@dnd-kit/core').Over | null, collisions?: import('@dnd-kit/core').Collision[] | null }} event
 * @returns {{ type: 'schedule-cell', row: Object, day: Date, dayKey: string }|null}
 */
export function getScheduleCellDropPayload(event) {
  const fromOver = readDndDataRef(event.over?.data);
  if (fromOver?.type === "schedule-cell") {
    return fromOver;
  }
  for (const c of event.collisions ?? []) {
    const container = c.data?.droppableContainer;
    const payload = readDndDataRef(container?.data);
    if (payload?.type === "schedule-cell") {
      return payload;
    }
  }
  return null;
}
